import { effect, inject, OnInit, Signal, untracked } from '@angular/core';
import { Dictionary } from '@softline/core';
import { SettingsComponent } from '@softline/ui-core';
import { PageSettingsService } from '../page-settings.service';
import { PageSettingsHostDirective } from './page-settings-host/page-settings-host.directive';

export abstract class PageSettingsDirectiveBase<T extends SettingsComponent> {

  readonly host = inject(PageSettingsHostDirective);
  readonly service = inject(PageSettingsService);

  abstract component: Signal<T>;
  abstract name: Signal<string>;

  componentEffect = effect(() => {
    const component = this.component();
    const name = this.name()
    const hostName = this.host.name()
    component.registerOnSettingsChange(
      (value: Dictionary<any>) => this.service.set(hostName, {name: name, settings: value})
    )
  });

  hostEffect = effect(() => {
    const name = this.name();
    const component = this.component();
    const pageSettings = this.service.pageSettings(name)();
    const componentSettings = pageSettings.components.find(o => o.name === name);
    if(componentSettings)
      untracked(() => component.applySettings(componentSettings.settings));
  });
}
